
import { defineComponent, PropType } from 'vue';
import { AssociationType } from '@/types/AssociationType';
import ReturnOptions from '@/components/ReturnOptions.vue';
import globalConstants from '@/shared/globalConstants';
import FbxButton from '@/components/fbx-button.vue';
const { knight, swift } = globalConstants.companies;

export default defineComponent({
    components: {
        ReturnOptions,
        FbxButton,
    },
    props: {
        trailerNumber: {
            type: String,
            required: true,
        },
        trailerCompany: {
            type: String,
            required: true,
        },
        hasBodyDamage: {
            type: String,
            required: true,
        },
        association: {
            type: String as PropType<AssociationType>,
            required: false,
            default: AssociationType.ATTACH,
        },
    },
    data: () => ({
        isFromDetachModal: false,
    }),
    computed: {
        assistanceButtonText(): string {
            return this.trailerCompany === 'knight'
                ? 'Call Breakdown'
                : 'Call OnRoad';
        },
        assistanceNumber(): string {
            return this.trailerCompany === 'knight'
                ? process.env.VUE_APP_KNIGHT_BREAKDOWN_NUMBER
                : process.env.VUE_APP_SWIFT_ONROAD_NUMBER;
        },
        bodyDamageContactText(): string {
            return this.trailerCompany === 'knight'
                ? `Breakdown (${this.assistanceNumber})`
                : `OnRoad (${this.assistanceNumber})`;
        },
        isDetach() {
            return this.association === AssociationType.DETACH;
        },
        returnApp(): string {
            const routeCompany = this.$route?.params?.company;

            if (routeCompany === knight) {
                return 'KT Mobile';
            } else if (routeCompany === swift) {
                return 'Pointe';
            } else {
                return '';
            }
        },
    },
    created() {
        this.isFromDetachModal = this.$route.query.fromDetachModal === 'true';
    },
});
